import { render, staticRenderFns } from "./duration-input.vue?vue&type=template&id=0c6e2314&scoped=true&"
import script from "./duration-input.vue?vue&type=script&lang=js&"
export * from "./duration-input.vue?vue&type=script&lang=js&"
import style0 from "./duration-input.vue?vue&type=style&index=0&id=0c6e2314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e2314",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})
